var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  gridEmpty: '[grid-wishlist-empty]',
  headerNotice: '[header-notice]',
  headerIcon: '.Icon--wishlist'
};

var headerIcons = document.querySelectorAll(selectors.headerIcon);
var headerNotices = document.querySelectorAll(selectors.headerNotice);
var gridEmpty = document.querySelector(selectors.gridEmpty);

document.addEventListener('DOMContentLoaded', function () {
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);

  var grid = document.querySelector(selectors.grid);
  if (grid) setupGrid(grid);

  updateHeaderIcon(WISHLIST.length);
});

document.addEventListener('click', function (e) {
  if (e.target.matches(selectors.button) || e.target.closest(selectors.button)) {
    buttonHandler(e);
  }
}, false);

document.addEventListener('wishlist:toggleButtonState', function (e) {
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
}, false);

var getSearchQueryString = function (items) {
  return items.map(function (item) {
    return 'id:' + item;
  }).join(' OR ');
};

var setupGrid = function (grid) {
  var queryString = getSearchQueryString(WISHLIST);
  var mobileGridSetting = '2';
  
  var gridElement = document.querySelector('.wishlist .grid');
  if (gridElement) {
    var mobileColumns = window.getComputedStyle(gridElement).getPropertyValue('--COLUMNS-MOBILE');
    if (mobileColumns) {
      mobileGridSetting = mobileColumns.trim();
    }
  }

  fetch(window.theme.routes.searchUrl + '?view=wishlist&type=product&q=' + queryString + '&mobile_grid=' + mobileGridSetting).then(function (res) {
    res.text().then(function (wishlistProductCards) {
      // Create a temporary div to parse the HTML response
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = wishlistProductCards;
      
      // Extract only the product grid items, ignoring any header/footer elements
      var productItems = tempDiv.querySelectorAll('.product-item, .grid-item, [data-product-id]');
      var paginationHTML = tempDiv.querySelector('.pagination, .grid__footer');
      var cleanHTML = '';
      
      if (productItems.length > 0) {
        productItems.forEach(function(item) {
          cleanHTML += item.outerHTML;
        });
      } else {
        // If no product items found, check for no-results message
        var noResults = tempDiv.querySelector('.no-results');
        if (noResults) {
          cleanHTML = noResults.outerHTML;
        }
      }
      
      grid.innerHTML = cleanHTML;
      var buttons = grid.querySelectorAll(selectors.button) || [];
      if (buttons.length) {
        setupButtons(buttons);
      } else {
        gridEmpty.style.display = 'block';
      }
      
      if (typeof window.initializeQuickAdd === 'function') {
        window.initializeQuickAdd();
      }
      
      // Initialize flickity dots for product cards in wishlist
      if (typeof window.initProductGridDots === 'function') {
        setTimeout(() => {
          window.initProductGridDots();
        }, 100);
      }
    });
  });
};

var buttonHandler = function (e) {
  e.preventDefault();
  var button = e.target.closest(selectors.button);
  var productId = button.dataset.productId || false;
  if (!productId) return console.error('[Wishlist] Missing `data-product-id` attribute. Failed to update the wishlist.');
  
  updateWishlist(productId);
  
  var matchingButtons = document.querySelectorAll(selectors.button + '[data-product-id="' + productId + '"]');
  matchingButtons.forEach(function(btn) {
    btn.classList.toggle(BUTTON_ACTIVE_CLASS);
  });
};

var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    var productId = button.dataset.productId || false;
    if (!productId) return console.error('[Wishlist] Missing `data-product-id` attribute. Failed to update the wishlist.');
    
    if (wishlistContains(productId)) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
    }
    button.style.visibility = 'visible';
  });
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setWishlist = function (array) {
  WISHLIST = array;
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist;
};

var updateHeaderIcon = function (count) {
  if (!headerIcons.length) return;

  headerIcons.forEach(function(icon) {
    // Remove existing classes
    icon.classList.remove('wishlist-active', 'wishlist-inactive');
    
    if (count > 0) {
      icon.classList.add('wishlist-active');
    } else {
      icon.classList.add('wishlist-inactive');
    }
  });
};

var updateWishlist = function (id) {
  var wishlist = WISHLIST;
  var indexInWishlist = wishlist.indexOf(id);
  var wasAdded = indexInWishlist === -1;
  
  if (wasAdded) {
    wishlist.push(id);
  } else {
    wishlist.splice(indexInWishlist, 1);
  }
  
  updateHeaderIcon(wishlist.length);
  
  if (headerNotices.length) {
    headerNotices.forEach(function(headerNotice) {
      headerNotice.innerHTML = wasAdded ? window.languages.wishlistItemAdded : window.languages.wishlistItemRemoved;
      var popover = headerNotice.closest(selectors.headerWishlistPopover);
      if (popover) {
        popover.classList.add('is-visible');
        setTimeout(function () {
          popover.classList.remove('is-visible');
        }, 2000);
      }
    });
  }

  setWishlist(wishlist);
  
  var grid = document.querySelector(selectors.grid);
  if (grid) {
    setupGrid(grid);
  }
};

var wishlistContains = function (id) {
  return WISHLIST.indexOf(id) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};

var WISHLIST = getWishlist();
